import { useQuery, useMutation } from '@tanstack/react-query';
import axiosClient from '../clients/axiosClient';
import { authKeys } from './queryKeys';

export function useValidateInvite(hash: string | undefined) {
  return useQuery({
    queryKey: authKeys.inviteValidate(hash ?? ''),
    queryFn: async () => {
      const { data } = await axiosClient.get<{ valid: boolean; email?: string }>(
        `/api/user/invite/${hash}`,
      );
      return data;
    },
    enabled: !!hash,
    retry: false,
    staleTime: Infinity,
  });
}

export function useAcceptInviteMutation() {
  return useMutation({
    mutationFn: (payload: {
      hash: string;
      username: string;
      password: string;
      firstName: string;
      lastName: string;
    }) =>
      axiosClient.post<{ user: unknown; token: string; refreshToken: string }>(
        '/api/user/invite/accept',
        payload,
      ),
  });
}

export function useValidateResetToken(token: string | undefined) {
  return useQuery({
    queryKey: authKeys.resetPasswordValidate(token ?? ''),
    queryFn: async () => {
      const { data } = await axiosClient.get<{ valid: boolean; email?: string }>(
        `/api/auth/reset-password/${token}`,
      );
      return data;
    },
    enabled: !!token,
    retry: false,
    staleTime: Infinity,
  });
}

export function useResetPasswordMutation() {
  return useMutation({
    mutationFn: (payload: { token: string; newPassword: string; confirmPassword: string }) =>
      axiosClient.post('/api/auth/reset-password', payload),
  });
}

export function useChangePasswordMutation() {
  return useMutation({
    mutationFn: (payload: { oldPassword: string; newPassword: string; confirmPassword: string }) =>
      axiosClient.post<{ message: string }>('/api/auth/change-password', payload),
  });
}
